import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import styled from 'styled-components';

const FileWrapper = ({ children, ...props }) => {
  return (
    <StyledFileWrapper backgroundColor="secondary" {...props}>
      {children}
    </StyledFileWrapper>
  );
};

const StyledFileWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.secondary};
  padding: 12px;
  border-radius: 12px;
`;

FileWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
export default FileWrapper;
